const resources = {
    signInLead: 'Ouvrir une session pour profiter de l’expédition GRATUITE',
    signInCTA: 'Ouvrir une session',
    signUpLead: 'Pas de compte?',
    signUpCTA: 'Créer un compte',
    status: 'Vous êtes',
    points: 'avec',
    join: 'S’inscrire à Beauty Insider',
    earn: 'pour accumuler des points à chaque achat.'
};

module.exports = function getResource(label, vars = []) {
    return resources[label];
};
